import LegalPage, { P, UL, Strong } from "@/components/LegalPage";

const sections = [
  {
    id: "scope",
    heading: "Scope — Professional B2B Services",
    body: (
      <P>
        PS GLOBAL SERIES, LLC operates strictly as a B2B service provider,
        purchasing agent and trade liaison. The Company{" "}
        <Strong>does not sell physical products</Strong>, does not operate
        an online store, does not take title to merchandise, and does not
        process consumer transactions. This Cancellation &amp; Refund Policy
        clarifies how our professional service fees are handled and how
        returns of physical goods are routed through the original suppliers.
      </P>
    ),
  },
  {
    id: "non-refundable-fees",
    heading: "Non-Refundable Service Fees",
    body: (
      <P>
        <Strong>
          Service and consulting fees are non-refundable once the engagement
          has commenced.
        </Strong>{" "}
        This includes retainer fees, hourly consulting fees, intermediation
        commissions and any other fees agreed in the Statement of Work.
        Because these fees compensate the time, expertise and dedicated
        analytical resources allocated to the Client&apos;s engagement from
        the moment work begins, they are not refundable in part or in whole
        after such commencement.
      </P>
    ),
  },
  {
    id: "returns-of-goods",
    heading: "Returns of Physical Goods",
    body: (
      <P>
        For physical merchandise, returns and replacements are governed
        strictly by the policies of the original U.S. suppliers. PS GLOBAL
        SERIES, LLC acts <Strong>solely as an intermediary</Strong> in the
        management of the claim and is not responsible for the supplier&apos;s
        return acceptance, refund timing or restocking conditions. We will,
        upon written request, coordinate the Client&apos;s claim with the
        relevant supplier under their published return policy.
      </P>
    ),
  },
  {
    id: "cancellation",
    heading: "Cancellation of Future Services",
    body: (
      <P>
        The Client may terminate the request for future services at any time
        by sending an email to{" "}
        <a
          href="mailto:info@psglobalseries.com"
          className="text-slate-900 font-semibold hover:text-[#B45309]"
        >
          info@psglobalseries.com
        </a>
        . In the event of cancellation, only the intermediation services
        rendered up to the notification date will be billed. Amounts already
        paid for work in progress or delivered remain non-refundable per the
        clause above.
      </P>
    ),
  },
  {
    id: "electronic-delivery",
    heading: "Electronic Delivery — No Physical Shipments",
    body: (
      <>
        <P>
          All deliverables produced by PS GLOBAL SERIES, LLC (proposals,
          supplier shortlists, negotiation memos, sourcing roadmaps and
          trade-liaison reports) are delivered electronically to the
          corporate email address designated by the Client, or through the
          secure channel agreed in the Statement of Work.
        </P>
        <UL
          items={[
            "PS GLOBAL SERIES, LLC does not perform physical shipments of inventory.",
            "No products, samples, materials or inventory are handled or transported by the Company.",
            "The delivery window for each deliverable is specified in the signed Statement of Work.",
          ]}
        />
      </>
    ),
  },
  {
    id: "payment-disputes",
    heading: "Payment Disputes",
    body: (
      <P>
        Before initiating any dispute with your payment processor or
        financial institution, please contact us first at{" "}
        <a
          href="mailto:info@psglobalseries.com"
          className="text-slate-900 font-semibold hover:text-[#B45309]"
        >
          info@psglobalseries.com
        </a>{" "}
        with the relevant documentation. We will acknowledge your
        communication within two (2) business days and work in good faith to
        reach a timely resolution under the applicable clauses of our Terms
        of Service.
      </P>
    ),
  },
  {
    id: "contact",
    heading: "Contact",
    body: (
      <>
        <P>
          For any inquiries regarding cancellation, refunds, returns
          coordination or electronic delivery, contact PS GLOBAL SERIES,
          LLC at:
        </P>
        <UL
          items={[
            "Email: info@psglobalseries.com",
            "Phone: +1 (339) 565-8894",
            "State of Formation: New Mexico, USA (Limited Liability Company).",
            "Mailing address: 7345 W Sand Lake Rd, Ste 210, Office 7485, Orlando, FL 32819, United States.",
          ]}
        />
      </>
    ),
  },
];

export default function RefundPolicy() {
  return (
    <LegalPage
      testId="page-refund-policy"
      eyebrow="Legal"
      title="Cancellation & Refund Policy"
      lastUpdated="June 2026"
      intro={
        <>
          This policy explains how service fees, cancellations and returns
          are handled under the B2B service model of PS GLOBAL SERIES, LLC.
          Service and consulting fees are non-refundable once the engagement
          has commenced; returns of physical goods are governed strictly by
          the policies of the original U.S. suppliers, with PS GLOBAL
          SERIES, LLC acting solely as an intermediary in the management of
          the claim.
        </>
      }
      sections={sections}
    />
  );
}
